import styled from "styled-components";

const ParagraphStyles = styled.p`
  font-style: normal;
  font-weight: ${({ theme }) => theme.typography.body.b2.weight};
  font-size: ${({ theme }) => theme.typography.body.b2.size};
  line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
  word-break: break-all;
  color: ${({ theme }) => theme.colors.semantic.text.strong};
`;

const Paragraph = ({ children, onClick, className, style }) => (
  <ParagraphStyles className={className} onClick={onClick} style={{ ...style }}>
    {children}
  </ParagraphStyles>
);

export default Paragraph;
